import { render, staticRenderFns } from "./ProjectWindowView.vue?vue&type=template&id=46a47a09&scoped=true&"
import script from "./ProjectWindowView.vue?vue&type=script&lang=js&"
export * from "./ProjectWindowView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a47a09",
  null
  
)

export default component.exports